import {getSessionGeneration, onSessionGenerationChange} from '../../lib/sessionGeneration.js'
export const freshAuthorityInitial = () => ({phase: 'idle', data: null, error: '', receivedAt: null})
export function createFreshAuthorityController({id, read, onChange = () => {}, now = () => new Date().toISOString()}) {
  let state = freshAuthorityInitial(), disposed = false, run = 0, abort = null
  const publish = next => {if (!disposed) {state = next; onChange(state)}}
  const unsubscribe = onSessionGenerationChange(() => {
    run++; abort?.abort(); abort = null
    publish({...freshAuthorityInitial(), error: 'The signed-in session changed. Read again with current authority.'})
  })
  return {
    snapshot: () => state,
    async load() {
      if (disposed || state.phase === 'loading' || !String(id || '').trim()) return
      const ticket = ++run, generation = getSessionGeneration(); abort = new AbortController()
      const active = () => !disposed && ticket === run && generation === getSessionGeneration()
      publish({...freshAuthorityInitial(), phase: 'loading'})
      try {
        const data = await read(String(id), {signal: abort.signal})
        if (!active()) return
        if (data?.ok !== true || String(data.id) !== String(id) || !data.record || typeof data.record !== 'object') throw new Error('The fresh record did not match the selected championship.')
        const authority = data.authority
        if (authority?.canViewFreshRecord !== true || authority?.canViewCompany !== true || authority?.scope !== 'company' || authority?.basis !== 'current_roster_and_canonical_championship_assignment') {
          publish({...freshAuthorityInitial(), phase: 'denied', error: 'The server did not grant current manager inspection scope.'}); return
        }
        publish({phase: 'ready', data, error: '', receivedAt: now()})
      } catch (error) {
        if (!active()) return
        publish({...freshAuthorityInitial(), phase: error?.status === 401 || error?.status === 403 ? 'denied' : 'error', error: error?.message || 'The current account authority could not be read.'})
      } finally {if (active()) abort = null}
    },
    dispose() {disposed = true; run++; abort?.abort(); unsubscribe()},
  }
}
